import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Store from "./ReduxStore/Store/Store";
import { PriceProvider } from "./context/PriceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <Provider store={Store}>
      <PriceProvider>
        <App />
      </PriceProvider>
    </Provider>
  </HashRouter>
);

// React app render 
// Loader hide logic is now managed in App.jsx (3-second timeout)
